module.exports = __webpack_public_path__ + "images/index/img03.3e73f29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro/EDU/img03.jpg
// module id = Z+3T
// module chunks = 21